import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { footerLinks } from '../../data/navigation';
import { SITE } from '../../data/site';
import { Logo } from '../ui/Logo';
import { StarDivider } from '../ui/StarDivider';
import { MapEmbed } from '../shared/MapEmbed';
import { NewsletterForm } from '../forms/NewsletterForm';
export function Footer() {
  const loc = SITE.location;
  return <footer className="bg-ink pb-20 text-chrome-300 md:pb-0" data-id="element-323" data-mp="pu63lqpwi7c">
      <div className="chrome-line opacity-40" aria-hidden="true" data-id="element-324" data-mp="3s1vkukfn94a7" />
      <div className="gutter grid gap-12 py-16 md:grid-cols-2 xl:grid-cols-12 xl:gap-10" data-id="element-325" data-mp="3n32fxgefalln">
        <div className="xl:col-span-3" data-id="element-326" data-mp="3j28uctogdivx">
          <Logo data-id="element-327" data-mp="3j3a2apa69p9f" />
          <p className="mt-6 max-w-[34rem] text-sm leading-relaxed" data-id="element-328" data-mp="3j3tlsafh0lpk">
            Homeland Personal Protection is a Las Vegas defensive firearms academy offering Nevada and Multi-State CCW classes, CCW renewals, defensive handgun and carbine training, women-only classes, and NRA and USCCA courses.
          </p>
          <div className="mt-6 flex flex-wrap gap-2" data-id="element-329" data-mp="2kb0cftdlpl32">
            <span className="chrome-plate rounded-[3px] px-3 py-1.5 font-display text-xs font-semibold uppercase tracking-wider text-navy" data-id="element-330" data-mp="2p4v0ta45io8h">NRA Certified Instructors</span>
            <a href={SITE.usccaPartner} className="chrome-plate rounded-[3px] px-3 py-1.5 font-display text-xs font-semibold uppercase tracking-wider text-navy" data-id="element-331" data-mp="2gb9l9ok5x2y0">
              USCCA Partner
            </a>
          </div>
        </div>

        <div className="xl:col-span-3" data-id="element-332" data-mp="381e4vl03lly6">
          <h2 className="font-display text-sm font-semibold uppercase tracking-[0.12em] text-white" data-id="element-333" data-mp="380cqp7nscjc8">Classroom location</h2>
          <div className="mt-4 overflow-hidden rounded-[4px] border border-white/10" data-id="element-334" data-mp="2z1r491f70k66">
            <MapEmbed className="h-44" data-id="element-335" data-mp="1inr4prk9ewjg" />
            <div className="flex gap-3 bg-white/[0.04] p-4 text-sm" data-id="element-336" data-mp="1impv7riw6i3u">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-bright" aria-hidden="true" data-id="element-337" data-mp="1nmkg9efzkdgz" />
              <address className="not-italic leading-relaxed" data-id="element-338" data-mp="13l97qiswzq6t">
                <span className="text-white" data-id="element-339" data-mp="13mtz5zjxmt0g">{loc.venue}</span>
                <br data-id="element-340" data-mp="zkfinm3qk5cc" />
                {loc.street}, {loc.city}, {loc.region} {loc.postal}
                <br data-id="element-341" data-mp="ure1f7g23tpl" />({loc.area})
              </address>
            </div>
          </div>
        </div>

        <nav className="xl:col-span-3" aria-label="Footer" data-id="element-342" data-mp="ps9uyokioa2y">
          <h2 className="font-display text-sm font-semibold uppercase tracking-[0.12em] text-white" data-id="element-343" data-mp="ku877qc5bml5">Explore</h2>
          <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5 text-sm" data-id="element-344" data-mp="funbdos9vucn">
            {footerLinks.map(l => <li key={l.label} data-id="element-345" data-mp="bss1vx06uans">
                {l.external ? <a href={l.to} className="hover:text-white" data-id="element-346" data-mp="6ugrnl5zdy51">
                    {l.label}
                  </a> : <Link to={l.to} className="hover:text-white" data-id="element-347" data-mp="266jijggxpusq">
                    {l.label}
                  </Link>}
              </li>)}
          </ul>
          <div className="mt-6 space-y-2 text-sm" data-id="element-348" data-mp="28siq0ukv7pd2">
            <a href={SITE.social.ccwMaggie} className="flex items-center gap-2 hover:text-white" data-id="element-349" data-mp="28pwmr750bw0n">
              <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-350" data-mp="2dp0tzs8dfjoc" /> @CCWMaggie
            </a>
            <a href={SITE.social.womensDefenseNetwork} className="flex items-center gap-2 hover:text-white" data-id="element-351" data-mp="2iilt5nlpajp4">
              <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-352" data-mp="2nizwisccx5gt" /> Women’s Defense Network
            </a>
          </div>
        </nav>

        <div className="xl:col-span-3" data-id="element-353" data-mp="1urpwod6av0bj">
          <h2 className="font-display text-sm font-semibold uppercase tracking-[0.12em] text-white" data-id="element-354" data-mp="1usrh3897gz5x">Talk to a real person</h2>
          <a href={SITE.phoneHref} className="mt-4 flex items-center gap-2 font-display text-3xl font-semibold text-white hover:text-chrome-100" data-id="element-355" data-mp="1ztoyvjqazr6w">
            <PhoneIcon className="h-6 w-6 text-accent-bright" aria-hidden="true" data-id="element-356" data-mp="3b5g2ppgzbynt" />
            {SITE.phoneDisplay}
          </a>
          <p className="mt-1 text-sm" data-id="element-357" data-mp="3f69q8hqifbg6">We train 7 days a week.</p>
          <div className="mt-8" data-id="element-358" data-mp="3dq4d1mlyzjq0">
            <NewsletterForm data-id="element-359" data-mp="3dr5zen8frsn1" />
          </div>
        </div>
      </div>
      <div className="gutter flex flex-col items-center justify-between gap-4 border-t border-white/10 py-6 text-xs md:flex-row" data-id="element-360" data-mp="38sw3gaew0o0d">
        <p data-id="element-361" data-mp="3nqeqn8bx2t5p">© {new Date().getFullYear()} Homeland Personal Protection LLC. Making America Safe Again.</p>
        <StarDivider data-id="element-362" data-mp="3is3eus22a8ku" />
      </div>
    </footer>;
}